<template>
    <div class="center-page">
        <el-tabs v-model="activeName">
            <el-tab-pane label="东瀛民宿平台服务条款" name="1">
                <div style="line-height: 1.5;" v-html="serviceAgreement.content"></div>
            </el-tab-pane>
            <el-tab-pane label="东瀛民宿隐私政策" name="2">
                <div style="line-height: 1.5;" v-html="yinsiAgreement.content"></div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "clause",
        data() {
            return {
                activeName: '1'
            }
        },
        computed:{
            ...mapState(['serviceAgreement', 'yinsiAgreement'])
        }
    }
</script>

<style scoped>

</style>
